// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ABIUpload_wrapper__3E6Re","label":"ABIUpload_label__3Uedw","form":"ABIUpload_form__urhzD"};